module.exports = __webpack_public_path__ + "static/media/notifications-empty.874472d8.svg";